import React, { createContext, Fragment } from 'react'
import { Redirect } from 'react-router'
import Navbar from './Navabar/Navbar'
import MainContent from './Content/MainContent'

function Index() {
    const token = localStorage.getItem('token-helpdesk-umy')
    if (!token) {
        return <Redirect to="/login"></Redirect>
    }

    return (
        <Fragment>
            <div id="app">
                <div className="main-wrapper">
                    <Navbar />
                    <MainContent />
                    {/* <Footer /> */}
                </div>
            </div>
        </Fragment>
    )
}

export default Index
